import { Labels, useDataTypesHooks, useDescribeHooks } from "../../../../../features/data-types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailFieldProps, DetailPanel, FieldType, FieldValue, UIPermission, useGetCrumbs } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { CompanyUserName, useSystemStateHooks } from "../../../../system"
import { Period, Tax, TaxBase, TaxType } from "../../../state/types"

export const TaxDetail = () => {
  const { dataType } = useRoutesHooks().parseUrl()
  const tax = dataType! as Tax

  const { userHasPermission } = useSystemStateHooks()
  const readOnly = !userHasPermission(UIPermission.SAVE_TAXES) || tax.archived || tax.type === TaxType.VAT
  const { describe } = useDescribeHooks()
  const { formatDateTime } = useDataTypesHooks()

  const title = describe(TableName.TAXES, tax)
  const crumbs = useGetCrumbs(
    'Impuestos',
    RoutePath.TAXES,
    tax.name
  )

  const fields: DetailFieldProps[] = [
    { name: 'name', type: FieldType.TEXT, label: 'Nombre' },
    {
      name: 'type',
      type: FieldType.TEXT,
      label: 'Tipo',
      render: (value?: FieldValue) => <>{Labels.taxTypeLabel(value! as TaxType)}</>
    },
    {
      name: 'code',
      type: FieldType.TEXT,
      label: 'Código Interno'
    },
    {
      name: 'taxBase',
      type: FieldType.TEXT,
      label: 'Base Imponible',
      render: (value?: FieldValue) => <>{Labels.taxBaseLabel(value! as TaxBase)}</>
    },
    {
      name: 'nonTaxableMin',
      type: FieldType.PRICE,
      label: 'Mínimo No Imponible'
    },
    {
      name: 'yield',
      type: FieldType.PERCENTAGE,
      label: 'Alícuota'
    }
  ]
  if (tax.nonTaxableMinPeriod) {
    const nonTaxableMinPeriodField = {
      name: 'nonTaxableMinPeriod',
      type: FieldType.TEXT,
      label: 'Período',
      render: (value?: FieldValue) => <>{Labels.periodLabel(value! as Period)}</>
    }
    fields.splice(4, 0, nonTaxableMinPeriodField)
  }

  if (tax.negativeStateUserId) {
    fields.push({
      name: 'negativeStateUserId',
      type: FieldType.TEXT,
      label: 'Archivado por',
      render: () => {
        const dateStr = tax.negativeStateAt ? ` - ${formatDateTime(new Date(tax.negativeStateAt))}` : ''
        return <><CompanyUserName userId={tax.negativeStateUserId!} />{dateStr}</>
      }
    })
  }

  return (
    <DetailPanel
      tableName={TableName.TAXES}
      title={title}
      crumbs={crumbs}
      fields={fields}
      data={tax}
      icon='coin'
      readOnly={readOnly}
    />
  )
}
